import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'app-table-container',
	templateUrl: 'table-container.component.html',
	styleUrls: ['table-container.component.scss']
})
export class TableContainerComponent {}
